import t from "@/lang/lang";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";

/**
 * workOrderStateActionLabel returns the label of the transition into the
 * state, as shown to users. It names the action, not the state: a user starts
 * the execution ("Ausführung beginnen"), the work order then is in execution
 * ("Ausführung").
 */
export function workOrderStateActionLabel(state: FulfillmentState): string {
  switch (state) {
    case FulfillmentState.Planning:
      return t("Neu Planen");
    case FulfillmentState.Execution:
      return t("Ausführung beginnen");
    case FulfillmentState.Executed:
      return t("Vollständig ausgeführt");
    case FulfillmentState.PartiallyExecuted:
      return t("Teilweise ausgeführt");
    case FulfillmentState.Completed:
      return t("Fertigstellen");
    case FulfillmentState.Cancelled:
      return t("Stornieren");
    default:
      return t(state);
  }
}
